import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Logo from '@starbucks-web/pattern-library/lib/components/logo';
import { legacyBaseUrlSelector } from 'shared/app/state/selectors/locales';

import { commonMessages } from 'shared/app/messages';
import { useSelector } from 'react-redux';

const LogoWithA11yName = (props) => {
  const { formatMessage } = useIntl();
  const href = useSelector(legacyBaseUrlSelector) || '/';
  const logoProps = { href, ...props };
  return (
    <Logo ariaLabel={formatMessage(commonMessages.logoLabel)} {...logoProps} />
  );
};

LogoWithA11yName.propTypes = {
  href: PropTypes.string,
};

export default LogoWithA11yName;
